import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import QuizLanding from './pages/QuizLanding';
import Quiz from './pages/Quiz';
import QuizResults from './pages/QuizResults';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/quiz-landing" replace />} />
          <Route path="/quiz-landing" element={<QuizLanding />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/results" element={<QuizResults />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
